import { create } from "zustand";
import { axiosHelper } from "./helpers";

export const useFeedbackStore = create((set, get) => ({
    dashboardData: null,
    feedbacks: [],
    pagination: null,
    isLoading: false,
    isTableLoading: false,
    isError: false,
    error: null,

    fetchDashboardData: async (params = {}) => {
        set({ isLoading: true, isError: false });
        try {
            const queryParams = new URLSearchParams();
            if (params.siteIds?.length) queryParams.append("siteIds", params.siteIds.join(","));
            if (params.spaceIds?.length) queryParams.append("spaceIds", params.spaceIds.join(","));
            if (params.startDate) queryParams.append("startDate", params.startDate.toISOString());
            if (params.endDate) queryParams.append("endDate", params.endDate.toISOString());
            if (params.ratings?.length) queryParams.append("ratings", params.ratings.join(","));

            const response = await axiosHelper.get(`/feedback/dashboard?${queryParams.toString()}`);
            if (response.success) {
                set({
                    dashboardData: response.data,
                    feedbacks: response.data.feedbacks,
                    pagination: response.data.pagination,
                    isLoading: false
                });
                return response.data;
            }
        } catch (error) {
            set({ isLoading: false, isError: true, error: error.message });
            return null;
        }
    },

    fetchFeedbacks: async (params = {}) => {
        set({ isTableLoading: true });
        try {
            const queryParams = new URLSearchParams();
            if (params.siteIds?.length) queryParams.append("siteIds", params.siteIds.join(","));
            if (params.spaceIds?.length) queryParams.append("spaceIds", params.spaceIds.join(","));
            if (params.startDate) queryParams.append("startDate", params.startDate instanceof Date ? params.startDate.toISOString() : params.startDate);
            if (params.endDate) queryParams.append("endDate", params.endDate instanceof Date ? params.endDate.toISOString() : params.endDate);
            if (params.ratings?.length) queryParams.append("ratings", params.ratings.join(","));

            queryParams.append("page", params.page || 1);
            queryParams.append("limit", params.limit || 10);

            const response = await axiosHelper.get(`/feedback/list?${queryParams.toString()}`);
            if (response.success) {
                set({
                    feedbacks: response.data.feedbacks,
                    pagination: response.data.pagination,
                    isTableLoading: false
                });
                return response.data;
            }
        } catch (error) {
            set({ isTableLoading: false, isError: true });
            return null;
        }
    },
}));
